import React from 'react'
import { AppBar } from '@material-ui/core'
import { ThemeProvider } from '@material-ui/styles'
// import PurchaseButton from "app/fuse-layouts/shared-components/PurchaseButton";
// import PoweredByLinks from "app/fuse-layouts/shared-components/PoweredByLinks";
import { useSelector } from 'react-redux'

function FooterLayout3(props) {
    const footerTheme = useSelector(({ fuse }) => fuse.settings.footerTheme)

    return (
        <ThemeProvider theme={footerTheme}>
            <AppBar id="fuse-footer" className="relative z-10" color="default">
                <div className="py-12 text-center w-full">Copyright © Runningman. All Rights Reserved.</div>
            </AppBar>
        </ThemeProvider>
    )
}

export default FooterLayout3
